import { Box, Chip, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
    formatReportDateRangeLabel,
    getReportDateChipLabel,
} from 'shared/lib/reportDatePresets';
import { BackButton } from 'shared/ui/BackButton';

interface ReportDrillInHeaderProps {
    title: string;
    dateFrom: Date;
    dateTo: Date;
    datePreset?: string | null;
    onBack: () => void;
    backButtonTitle: string;
    backButtonId?: string;
}

export const ReportDrillInHeader = ({
    title,
    dateFrom,
    dateTo,
    datePreset,
    onBack,
    backButtonTitle,
    backButtonId,
}: ReportDrillInHeaderProps) => {
    const { t } = useTranslation();
    const formattedRangeLabel = useMemo(
        () => formatReportDateRangeLabel(dateFrom, dateTo),
        [dateFrom, dateTo],
    );
    const dateChipLabel = useMemo(
        () =>
            getReportDateChipLabel(
                {
                    datePreset,
                    formattedRangeLabel,
                },
                t,
            ),
        [datePreset, formattedRangeLabel, t],
    );

    return (
        <>
            <BackButton
                id={backButtonId}
                onBack={onBack}
                title={backButtonTitle}
            />
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: 3,
                }}
            >
                <Typography
                    variant="h5"
                    sx={{ fontWeight: 500, color: 'common.black' }}
                >
                    {title}
                </Typography>
                <Chip
                    label={dateChipLabel}
                    variant="outlined"
                    sx={{
                        fontSize: 12,
                        backgroundColor: 'grey.100',
                        border: 'none',
                    }}
                />
            </Box>
        </>
    );
};
